import {Injectable} from "@angular/core";
import {ActionsObservable, ofType, StateObservable} from "redux-observable-es6-compat";
import {ApplicationCatalogActions} from "../Actions/application-catalog-actions";
import {IAppSpec, ISelectorState} from "../selector.state";
import {ApplicationToolbarActions} from "../Actions/application-toolbar-actions";
import {ApplicationSpecActions} from "../Actions/application-spec-actions";
import {filter, map, mergeMap, take, toArray} from "rxjs/operators";
import {ActionLocal} from "../Actions/actions.service";
import {combineLatest, EMPTY, from, Observable} from "rxjs";
import {Ic} from "../../models/common";
import {AcceptorCreator} from "../../models/acceptor/IAcceptor";
import {UpdateDesignCreator} from "../../models/IUpdateDesign";
import {ISpec} from "../../models/ISpec";
import {HttpClient} from "@angular/common/http";
import * as R from "ramda";
import {getSoluctionEfficiency} from "../../commonUtil";

/**
 * Created by claudio iozzia on 08/06/2017.
 */

@Injectable()
export class AcceptSortSolutionsEpics {

 private _updateSolutionsEfficiency(app: string, ics: Ic[], spec: ISpec<number>): Observable<Ic[]> {
     return from(ics).pipe(
       mergeMap(x => getSoluctionEfficiency(this.http, app, x, spec)),
       take(ics.length),
       toArray()
     );
  }

  private _filterSolutions(ics: Ic[], filterStr: string, spec: IAppSpec, accCreatorFn: AcceptorCreator, inFrame: boolean) {
    function validRegExp(): RegExp {
      try {return new RegExp(filterStr.replace(/\./g, '\\.'), 'i'); } catch (e) {return new RegExp(''); }
    }
    const re = validRegExp();

    if (inFrame) {
      // remove isolated buck topology designs when shown in powertree
      return ics.filter(a => !a.id.includes('dcdc:isolated buck'))
        .filter(b => re.test(b.CPN))                      // part number label filter
        .filter(c => accCreatorFn(c).accept(c, spec));
    }
    return ics.filter(a => re.test(a.CPN))                      // part number label filter
              .filter(b => accCreatorFn(b).accept(b, spec));     // Acceptor
              // .map(x => updCreatorFn(x).updateDesign(x, spec));    // updateDesign
//      .map(x=> {if (!isNullOrUndefined(x.warning) && x.warning.severity !== 0) console.log("Warning Severity:", x); return x})
  }

  private _orderSolutions(ics, sorterFn, dir, sortField) {
    return ics
      .concat()                                   // to create a copy
      .sort((a, b) => sorterFn(a, b, dir, sortField));                       // Comparator
  }


  constructor(private http: HttpClient) { }

  listeningAcceptorActions = (action$) => {

    const actionsToRefresh: string[] = [
      ApplicationToolbarActions.ActionType.SEARCH,
      ApplicationSpecActions.ActionType.UPDATE_FEATURE_FILTER,
      ApplicationSpecActions.ActionType.INPUT_SET_VALUE,
      ApplicationSpecActions.ActionType.OUTPUT_ADD,
      ApplicationSpecActions.ActionType.OUTPUT_REMOVE,
      ApplicationSpecActions.ActionType.OUTPUT_SET_VALUE,
      ApplicationSpecActions.ActionType.SINGLE_OUTPUT_SET_VALUE,
      ApplicationSpecActions.ActionType.RESET_SPECS,
    ];
    const _loadComplete = action$.pipe(ofType( ApplicationCatalogActions.ActionType.LOAD_COMPLETE));
    const _specChange = action$.pipe(filter((x: ActionLocal) => actionsToRefresh.includes(x.type)));

    return combineLatest([_loadComplete, _specChange]).pipe(
      mergeMap(() => {
        return from([ApplicationSpecActions.validateSpecs(), ApplicationCatalogActions.acceptSolutions()]);
      })
    );
  }

  acceptSolutions = (action$, store) => {
    return action$.pipe(
      ofType(ApplicationCatalogActions.ActionType.ACCEPT_SOLUTIONS),
      // .debounceTime(100)            //TODO to check
      mergeMap(() => {
        const catalog = store.value.appCatalog.db;
        const searchFilter = store.value.appToolBar.search;
        const appSpec = store.value.appSpec;
        const acceptorCreatorFn = store.value.appCatalog.service.acceptorCreator;
        const inFrame = store.value.appContext.frameMode;

        const solutions = this._filterSolutions(catalog, searchFilter, appSpec, acceptorCreatorFn, inFrame);
        // console.log("getSolution", searchFilter, appSpec, catalog, solutions);
          return from([ApplicationCatalogActions.updateSolutions(solutions)]);
      })
    );
  }

  updateSolutions = (action$, store) => {
    // const appSpec = () => store.value.appSpec;
    // const appName = () => store.value.appCatalog.appClass;
    // const updateSol = () => (!store.value.appContext.frameMode || appSpec().noteGlobal.hasError);

    return action$.pipe(
      ofType(ApplicationCatalogActions.ActionType.UPDATE_SOLUTIONS),
      map((act: ActionLocal) => {
        const _designSol = act.payload as Ic[];
        const updaterCreatorFn = store.value.appCatalog.service.updateDesignCreator as UpdateDesignCreator;
        return _designSol
                .map(x => R.assoc('efficiencyState', 'estimated', updaterCreatorFn(x).updateDesign(x, store.value.appSpec)));
      }),
      // mergeMap((solutions: Ic[]) => (updateSol() ? of(solutions) : this._updateSolutionsEfficiency(appName(), solutions, appSpec().spec.value) )),
      mergeMap( (solutions: Ic[]) => {
        return from([
          ApplicationCatalogActions.setDesignSolutions(solutions),
          ApplicationCatalogActions.orderSolutions()]
        );
      })
    );
  }

  startCalcEfficiency = (action$, store) => {
    return action$.pipe(
      ofType(ApplicationCatalogActions.ActionType.START_CALC_EFFICIENCY),
      mergeMap( (_) => {
        const _designSol = store.value.appCatalog.designSolutions.map(x => R.assoc('efficiencyState', 'calculating', x ));
        return from([
          ApplicationCatalogActions.setDesignSolutions(_designSol),
          ApplicationCatalogActions.calculate_efficiency(_designSol)
          ]
        );
      })
    );
  }

  calcEfficiency = (action$, store) => {
    const appSpec = () => store.value.appSpec;
    // const _appName = () => store.value.appCatalog.appClass;
    // const updateSol = () => (!store.value.appContext.frameMode || appSpec().noteGlobal.hasError);

    return action$.pipe(
      ofType(ApplicationCatalogActions.ActionType.CALC_EFFICIENCY),
      map((act: ActionLocal) => {
        return act.payload as Ic[];
      }),
      mergeMap((solutions: Ic[]) => this._updateSolutionsEfficiency(store.value.appCatalog.appClass, solutions, appSpec().spec.value) ),
      mergeMap( (solutions: Ic[]) => {
        return from([
          ApplicationCatalogActions.setDesignSolutions(solutions),
          ApplicationCatalogActions.orderSolutions()]
        );
      })
    );
  }

  orderSolutions = (action$: ActionsObservable<any>, store: StateObservable<ISelectorState>) => {
    const listeningAction: string[] = [
      ApplicationCatalogActions.ActionType.ORDER_SOLUTIONS,
      ApplicationToolbarActions.ActionType.SORT_FIELD,
      // ApplicationToolbarActions.ActionType.CHANGE_SORT_DIRECTION,
    ];
    return action$.pipe(
      filter((x: ActionLocal) => listeningAction.includes(x.type)),
      mergeMap(() => {
        const _designSol = store.value.appCatalog.designSolutions;
        const sortField = store.value.appToolBar.sortField;
        const direction = store.value.appToolBar.direction;
        const comparator = store.value.appCatalog.service.comparator;
        const appSpec = store.value.appSpec;

        const solutions = this._orderSolutions(_designSol, comparator.compareField(sortField, appSpec.specEdited), direction, sortField);
        return from([ApplicationCatalogActions.setDesignSolutions(solutions)]
        );
      })
    );
  }

  listeningResetLedSelection = (action$) => {
    const actionsToRefresh: string[] = [
      ApplicationSpecActions.ActionType.OUTPUT_ADD,
      ApplicationSpecActions.ActionType.OUTPUT_REMOVE,
      ApplicationSpecActions.ActionType.OUTPUT_SET_VALUE,
      ApplicationSpecActions.ActionType.SINGLE_OUTPUT_SET_VALUE,
      ApplicationSpecActions.ActionType.RESET_SPECS,
    ];

    return action$.pipe(
      filter((x: ActionLocal) => actionsToRefresh.includes(x.type)),
      mergeMap(() => {
        return  EMPTY; // of(ApplicationSpecActions.setSelectedLed(null));
      })
    );
  }
}


